module.exports = __webpack_public_path__ + "static/img/img7.de4e975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/img7.jpg
// module id = zBKq
// module chunks = 0